import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import RestartAltRoundedIcon from '@mui/icons-material/RestartAltRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';
import api from '../api';
import Pot from '../components/Pot'
import AppLayout from '../components/ui/AppLayout';
import PageHeader from '../components/ui/PageHeader';
import SectionCard from '../components/ui/SectionCard';
import PlayerAvatar from '../components/ui/PlayerAvatar';
import EmptyState from '../components/ui/EmptyState';
import tokens from '../theme/tokens';

const Pots = () => {
    
const [mensageSuccess, setMensageSuccess] = useState('');
const [success, setSuccess] = useState(false);
const [mensageError, setMensageError] = useState('');
const [error, setError] = useState(false);
const [load, setLoad] = useState(false); 
 
  const [eleitor, setEleitor] = useState([]);

  const [jogadores, setJogadores] = useState([]);
  const [jogadoresCompleto, setJogadoresCompleto] = useState([]);
  // Dentro do componente App
const [codigoVotacao, setCodigoVotacao] = useState(''); 
const [votoBranco, setVotoBranco] = useState(false); 

const [potes, setPotes] = useState({
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
  });

const [poteAtual, setPoteAtual] = useState(6);


const [isModalOpen, setIsModalOpen] = useState(false);
const [selectedPlayer, setSelectedPlayer] = useState(null);
const [selectedPot, setSelectedPot] = useState(poteAtual);
const [open, setOpen] = useState(false);
const [alert, setAlert] = useState(true);


const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseAlert = () => {
    setAlert(false);
  };

  const handleResetPotes = () => {
    // Zerar os potes
    const newPotes = {};
    for (let i = 1; i <= 6; i++) {
      newPotes[i] = [];
    }
    
    setPotes(newPotes);
  
    // Colocar todos os jogadores disponíveis novamente
    fetchPlayers(); 
  
    // Resetar o pote atual
    setPoteAtual(6);
  };
  
  const handleCloseError = () => {
    setError(false);
  };

  const showSuccess = async(msg)=>{
      setSuccess(true);
    setMensageSuccess(msg)
  }

  const handleCloseSuccess = () => {
    setSuccess(false);
  };

  const showError = async(msg)=>{
      setError(true);
    setMensageError(msg)
  }


 // Defina a função assíncrona getPlayers
 const getPlayers = async () => {
    try {
      const response = await api.get('get-players');
      const nomesJogadores = response.data.map(jogador => jogador.nome);
      setJogadoresCompleto(response.data)
      return nomesJogadores;
    } catch (error) {
      console.error('Erro ao obter jogadores:', error);
      return [];
    }
  };

  async function fetchPlayers() {
    const nomesJogadores = await getPlayers();
    setEleitor(nomesJogadores);
    setJogadores(nomesJogadores);
  }

  // Use o hook useEffect para buscar os jogadores ao montar o componente
  useEffect(() => {
   

    fetchPlayers();
  }, []);

  

  const handleDragStart = (e, jogador) => {
    e.dataTransfer.setData('text/plain', jogador);
  };

// Função para calcular o percentual de inserção de cada jogador
const calculatePercentages = (potes, jogadores) => {
  const jogadorOccurrences = {};
  for (const jogador of jogadores) {
    jogadorOccurrences[jogador] = 0;
  }

  for (const poteNum in potes) {
    for (const jogador of potes[poteNum]) {
      jogadorOccurrences[jogador]++;
    }
  }

  const totalPotes = Object.keys(potes).length;
  const jogadorPercentages = {};
  for (const jogador in jogadorOccurrences) {
    const occurrence = jogadorOccurrences[jogador];
    jogadorPercentages[jogador] = occurrence / totalPotes;
  }

  return jogadorPercentages;
};

// Função para reorganizar os jogadores nos potes com base nos percentuais
const rearrangePlayers = (potes, jogadores) => {
  const jogadorPercentages = calculatePercentages(potes, jogadores);

  for (const poteNum in potes) {
    potes[poteNum].sort((a, b) => jogadorPercentages[b] - jogadorPercentages[a]);

    while (potes[poteNum].length > 6) {
      const jogadorToRemove = potes[poteNum].pop();
      const poteNumToMove = parseInt(poteNum) - 1;

      if (poteNumToMove > 0) {
        potes[poteNumToMove].push(jogadorToRemove);
      }
    }
  }
};

// ...

// Função para lidar com o drop e reorganizar os jogadores
const handlePlayerRemove = (e, potNum, jogador) => {
  e.preventDefault();
  const newPotes = { ...potes };
  newPotes[potNum] = newPotes[potNum].filter(item => item !== jogador);

  // Adicionar o jogador de volta à lista de jogadores disponíveis apenas se ele não estiver mais em nenhum pote
  const jogadorInAnyPot = Object.values(newPotes).some(pote => pote.includes(jogador));
  const newJogadores = jogadorInAnyPot ? jogadores : [...jogadores, jogador];
  setJogadores(newJogadores);

  rearrangePlayers(newPotes, newJogadores);
  setPotes(newPotes);
};


const handleDrop = (e, potNum) => {
  e.preventDefault();

  // Verificar se o pote atual corresponde ao pote em que o jogador está sendo adicionado
  if (potNum<poteAtual) {
      showError(`Você só pode adicionar jogadores ao pote inferior após completar o pote ${poteAtual} com 6 jogadores.`);
    return;
  }

  const jogador = e.dataTransfer.getData('text/plain');
  const newPotes = { ...potes };

  // Verificar se o pote atual já possui 6 jogadores
  if (newPotes[potNum].length >= 6) {
    showError('O pote  já possui 6 jogadores.');
    return;
  }

  newPotes[potNum] = [...newPotes[potNum], jogador];

  // Remover o jogador da lista de jogadores disponíveis
  const newJogadores = jogadores.filter(item => item !== jogador);
  setJogadores(newJogadores);

  rearrangePlayers(newPotes, newJogadores);
  setPotes(newPotes);

  // Verificar se o pote atual está cheio
  if (newPotes[potNum].length >= 6) {
    // Encontrar o próximo pote inferior
    let nextPote = parseInt(potNum) - 1;
    while (nextPote >= 1 && newPotes[nextPote].length >= 6) {
      nextPote--;
    }
    setPoteAtual(nextPote);
  }
};

const createPotFromPlayerArray = (playersArray) => {
  const potObject = {
    jogador1: playersArray[0] || '',
    jogador2: playersArray[1] || '',
    jogador3: playersArray[2] || '',
    jogador4: playersArray[3] || '',
    jogador5: playersArray[4] || '',
    jogador6: playersArray[5] || '',
  };
  return potObject;
};

let potsFinal ={};
const preparaPots = async()=>{
  console.log(potes[6])
 
  potsFinal={
    1:createPotFromPlayerArray(potes[1]),
    2:createPotFromPlayerArray(potes[2]),
    3:createPotFromPlayerArray(potes[3]),
    4:createPotFromPlayerArray(potes[4]),
    5:createPotFromPlayerArray(potes[5]),
    6:createPotFromPlayerArray(potes[6])
  }
 
}

async function getPublicIP() {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error(error);
    return null;
  }
}



const handleEnviarPotes = async () => {
   
  const ip = await getPublicIP()

  let playerWithPotesData;
  if(votoBranco){
     playerWithPotesData = {
        ip:ip,
        votoBranco:votoBranco
      };

  }else{

      await preparaPots(potes);
      playerWithPotesData = {
       ip:ip,
       potes: potsFinal,
       votoBranco:votoBranco
     };
  }

  
console.log(playerWithPotesData);
  try {
    setLoad(true);
    playerWithPotesData.torneio_id= ''
    const response = await api.post('save-votos', playerWithPotesData);
    console.log('Resposta da API:', response.data);
    showSuccess('Lista de potes final enviada com sucesso!');
    handleResetPotes();
  } catch (error) {
    console.error('Erro ao enviar a lista de potes final:', error);
    showError('Erro ao enviar a lista de potes final: '+ error.response.data.message);
    if(error.response.data.voto){
        preenchePotes(error.response.data.voto)
    }
  }finally{
    setLoad(false)
  }
};


const preenchePotes = async(voto)=>{
    
    const newPotes = {};
    for (let i = 1; i <= 6; i++) {
      newPotes[i] = [];
    }
// Itere sobre as chaves do objeto 'potes.voto.potes'
for (const potNum in voto.potes) {
  // Verifique se o número do pote existe nos potes definidos anteriormente
  if (newPotes[potNum]) {
    // Extraia os jogadores do objeto 'potes.voto.potes[potNum]'
    const jogadores = Object.values(voto.potes[potNum]);
     // Exclua o jogador da posição 6, se existir
     if (jogadores.length >= 6) {
        jogadores.splice(6, 1);
      }
    console.log(jogadores);
    // Adicione os jogadores ao pote correspondente no novo objeto 'newPotes'
    newPotes[potNum] = [...newPotes[potNum], ...jogadores];
  }
}

// Atualize o estado dos potes com o novo objeto
setPotes(newPotes);
setJogadores([])
}



const openModal = (jogador) => {
  setSelectedPlayer(jogador);
  setIsModalOpen(true);
};

const closeModal = () => {
  setIsModalOpen(false);
  setSelectedPlayer(null);
  setSelectedPot(poteAtual);
};

const handlePotSelect = (potNum) => {
  setSelectedPot(potNum);
};

const handleAddToPot = () => {




  if (selectedPot !== '') {
    // Adicione aqui a lógica para adicionar o jogador ao pote selecionado
    // Pode usar a mesma lógica que você usou no drag and drop

// Verificar se o pote atual corresponde ao pote em que o jogador está sendo adicionado
if (selectedPot<poteAtual) {
    showError(`Você só pode adicionar jogadores ao pote inferior após completar o pote ${poteAtual} com 6 jogadores.`);
return;
}

const jogador = selectedPlayer;
const newPotes = { ...potes };

// Verificar se o pote atual já possui 6 jogadores
if (newPotes[selectedPot].length >= 6) {
    showError('O pote atual '+selectedPot+' já possui 6 jogadores.');
return;
}

newPotes[selectedPot] = [...newPotes[selectedPot], jogador];

// Remover o jogador da lista de jogadores disponíveis
const newJogadores = jogadores.filter(item => item !== jogador);
setJogadores(newJogadores);

rearrangePlayers(newPotes, newJogadores);
setPotes(newPotes);

// Verificar se o pote atual está cheio
if (newPotes[selectedPot].length >= 6) {
// Encontrar o próximo pote inferior
let nextPote = parseInt(selectedPot) - 1;
while (nextPote >= 1 && newPotes[nextPote].length >= 6) {
  nextPote--;
}
setPoteAtual(nextPote);
}

    closeModal(); // Feche o modal após adicionar o jogador
  }
};

const handleVotoBrancoSim= ()=>{
    setVotoBranco(true);
    setOpen(false);
}
const handleVotoBrancoNao= ()=>{
    setVotoBranco(false);
    setOpen(false);
}
const getFirstTwoWords = (str) => {
  return str.split(' ').slice(0, 2).join(' ');
};


const infoJogador = (nome) => jogadoresCompleto.find(k => k.nome === nome) || {};
const totalNosPotes = Object.values(potes).reduce((t, p) => t + p.length, 0);

  return (
   <AppLayout maxWidth="xl">
      <Snackbar open={error} onClose={handleCloseError} autoHideDuration={6000} anchorOrigin={{ vertical:'bottom', horizontal:'center' }} >
        <MuiAlert elevation={6} variant="filled" severity="warning" onClose={handleCloseError} sx={{ width: '100%' }}>
          {mensageError}
        </MuiAlert>
      </Snackbar>
      <Snackbar open={success} onClose={handleCloseSuccess} autoHideDuration={6000} anchorOrigin={{ vertical:'bottom', horizontal:'center' }} >
        <MuiAlert elevation={6} variant="filled" severity="success" onClose={handleCloseSuccess} sx={{ width: '100%' }}>
          {mensageSuccess}
        </MuiAlert>
      </Snackbar>

      <PageHeader
        eyebrow="Torneio"
        title="Monte seus potes"
        subtitle="Coloque os melhores jogadores nos potes de menor número. Comece pelo pote 6."
        actions={<Button variant="outlined" startIcon={<HelpOutlineRoundedIcon />} onClick={() => setAlert(true)}>Como votar</Button>}
      />

      <Grid container spacing={3}>
        <Grid item xs={12} lg={4}>
          <SectionCard
            title="Jogadores disponíveis"
            subtitle={`${jogadores.length} restantes de ${eleitor.length} inscritos`}
            sx={{ position: { lg: 'sticky' }, top: { lg: 88 } }}
          >
            {jogadores.length === 0 ? (
              <EmptyState title="Todos os jogadores foram alocados" description="Revise os potes e envie seu voto." />
            ) : (
              <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 1, maxHeight: { lg: 'calc(100vh - 260px)' }, overflowY: 'auto', pr: 0.5 }}>
                {jogadores.slice().sort().map((jogador) => (
                  <Tooltip key={jogador} title="Clique ou arraste para um pote">
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      draggable
                      onDragStart={(e) => handleDragStart(e, jogador)}
                      onClick={() => openModal(jogador)}
                      sx={{ p: 1, borderRadius: 2, border: 1, borderColor: 'divider', bgcolor: 'background.paper', cursor: 'grab', transition: 'all .15s', '&:hover': { borderColor: tokens.color.brand, boxShadow: tokens.shadow.sm } }}
                    >
                      <PlayerAvatar src={infoJogador(jogador).foto} name={jogador} size={32} />
                      <Box sx={{ minWidth: 0, flexGrow: 1 }}>
                        <Typography variant="body2" fontWeight={600} noWrap>{getFirstTwoWords(jogador)}</Typography>
                        <Typography variant="caption" color="text.secondary">Camisa {infoJogador(jogador).numeroCamisa ?? '-'}</Typography>
                      </Box>
                      <DragIndicatorRoundedIcon fontSize="small" sx={{ color: 'text.disabled' }} />
                    </Stack>
                  </Tooltip>
                ))}
              </Box>
            )}
          </SectionCard>
        </Grid>

        <Grid item xs={12} lg={8}>
          <SectionCard
            title="Seus potes"
            subtitle={poteAtual >= 1 ? `Preenchendo o pote ${poteAtual}` : 'Todos os potes completos'}
            actions={<Chip color={totalNosPotes === 36 ? 'success' : 'default'} label={`${totalNosPotes}/36 alocados`} />}
          >
            <Grid container spacing={2}>
              {Object.keys(potes).sort((a, b) => b - a).map((potNum) => (
                <Grid item xs={12} sm={6} md={4} key={potNum}>
                  <Pot
                    potNum={potNum}
                    playersInPot={potes[potNum]}
                    onDrop={(e) => handleDrop(e, potNum)}
                    onPlayerRemove={handlePlayerRemove}
                    showRemove={true}
                    active={Number(potNum) === poteAtual}
                  />
                </Grid>
              ))}
            </Grid>
          </SectionCard>

          <Card sx={{ mt: 3, p: 2 }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }} justifyContent="space-between">
              <FormControlLabel
                control={<Checkbox checked={votoBranco} onChange={handleClickOpen} />}
                label="Votar em branco"
              />
              <Stack direction="row" spacing={1}>
                <Button variant="outlined" color="inherit" startIcon={<RestartAltRoundedIcon />} onClick={handleResetPotes}>Limpar potes</Button>
                <Button variant="contained" size="large" startIcon={<SendRoundedIcon />} onClick={handleEnviarPotes}>Enviar meus potes</Button>
              </Stack>
            </Stack>
          </Card>
        </Grid>
      </Grid>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Votar em branco?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Tem certeza que deseja votar em branco? Seu voto é importante!
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleVotoBrancoNao} color="inherit">Não</Button>
          <Button onClick={handleVotoBrancoSim} variant="contained">Sim, votar em branco</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={alert} onClose={handleCloseAlert} maxWidth="sm">
        <DialogTitle>Como funciona a votação</DialogTitle>
        <DialogContent>
          <Stack spacing={1.5}>
            <DialogContentText>Coloque nos potes de <strong>menor número</strong> os jogadores que você considera melhores.</DialogContentText>
            <DialogContentText>O <strong>pote 1</strong> reúne os melhores; do 2 ao 6 o nível vai caindo.</DialogContentText>
            <DialogContentText>Comece pelo <strong>pote 6</strong>: cada pote aceita 6 jogadores e o próximo libera quando o atual estiver completo.</DialogContentText>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={handleCloseAlert} variant="contained">Entendi</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isModalOpen} onClose={closeModal} fullWidth maxWidth="xs">
        <DialogTitle>Adicionar ao pote</DialogTitle>
        <DialogContent>
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
            <PlayerAvatar src={infoJogador(selectedPlayer).foto} name={selectedPlayer || ''} size={44} />
            <Typography fontWeight={600}>{selectedPlayer}</Typography>
          </Stack>
          <TextField select fullWidth label="Pote" value={selectedPot} onChange={(e) => handlePotSelect(e.target.value)}>
            {Object.keys(potes).map((potNum) => (
              <MenuItem key={potNum} value={potNum} disabled={potes[potNum].length >= 6}>
                Pote {potNum} ({potes[potNum].length}/6)
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={closeModal} color="inherit">Cancelar</Button>
          <Button onClick={handleAddToPot} variant="contained">Adicionar</Button>
        </DialogActions>
      </Dialog>

      <Backdrop open={load} sx={{ color: '#fff', zIndex: 1400, flexDirection: 'column', gap: 2 }}>
        <CircularProgress color="inherit" />
        <Typography>Enviando seu voto...</Typography>
      </Backdrop>
   </AppLayout>
  );
};

export default Pots;
